/* eslint-disable linebreak-style */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from "react";
import { DiscussForm2 } from "parts/DiscussForm2";

import Header2 from "parts/Header2";
import Footer2 from "parts/Footer2";

export const DiscussProjectPage2 = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    Message: "",
  });

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onChange = (event) => {
    setData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
  };

  const resetForm = () => {
    setData({
      name: "",
      email: "",
      phone: "",
      Message: "",
    });
  };

  return (
    <>
      <Header2 />
      <DiscussForm2 data={data} onChange={onChange} resetForm={resetForm} />
      <Footer2 />
    </>
  );
};
